import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useCartStore = create(
  persist(
    (set, get) => ({
      items: [],

      addToCart: (product, quantity = 1) => {
        const items = get().items;
        const existingItem = items.find((item) => item._id === product._id);

        if (existingItem) {
          set({
            items: items.map((item) =>
              item._id === product._id
                ? { ...item, quantity: item.quantity + quantity }
                : item
            ),
          });
        } else {
          set({ items: [...items, { ...product, quantity }] });
        }
      },

      removeFromCart: (productId) => {
        set({ items: get().items.filter((item) => item._id !== productId) });
      },

      updateQuantity: (productId, quantity) => {
        if (quantity <= 0) {
          get().removeFromCart(productId);
          return;
        }

        set({
          items: get().items.map((item) =>
            item._id === productId ? { ...item, quantity } : item
          ),
        });
      },

      clearCart: () => {
        set({ items: [] });
      },

      getTotal: () => {
        const items = get().items;
        return items.reduce((total, item) => {
          // Calculate price based on quantity tiers
          let pricePerUnit = item.basePrice;
          
          if (item.priceTiers && item.priceTiers.length > 0) {
            const sortedTiers = [...item.priceTiers].sort((a, b) => b.quantity - a.quantity);
            for (const tier of sortedTiers) {
              if (item.quantity >= tier.quantity) {
                pricePerUnit = tier.pricePerUnit;
                break;
              }
            }
          }

          return total + pricePerUnit * item.quantity;
        }, 0);
      },

      getItemCount: () => {
        return get().items.reduce((count, item) => count + item.quantity, 0);
      },

      getCartItems: () => {
        const items = get().items;
        return items.map((item) => {
          let pricePerUnit = item.basePrice;
          
          if (item.priceTiers && item.priceTiers.length > 0) {
            const sortedTiers = [...item.priceTiers].sort((a, b) => b.quantity - a.quantity);
            for (const tier of sortedTiers) {
              if (item.quantity >= tier.quantity) {
                pricePerUnit = tier.pricePerUnit;
                break;
              }
            }
          }

          return {
            productId: item._id,
            name: item.name,
            quantity: item.quantity,
            pricePerUnit,
          };
        });
      },
    }),
    {
      name: 'cart-storage',
    }
  )
);

export default useCartStore;
